import { Customer } from "./customer";
import {
  CustomerAction,
  CustomerPrefillActionType,
  CustomerSaveActionType,
  CustomerTokenSaveActionType,
} from "./customer.actions";

export function customerReducer(
  state: CustomerState = {},
  action: CustomerAction
) {
  switch (action.type) {
    case CustomerSaveActionType:
      return {
        ...state,
        customer: action.customer,
      };
    case CustomerTokenSaveActionType:
      return {
        ...state,
        wcToken: action.wcToken,
      };
    case CustomerPrefillActionType:
      return {
        ...state,
        isPrefill: action.isPrefill,
      };

    default:
      return state;
  }
}

export interface CustomerState {
  customer?: Customer;
  wcToken?: string;
  isPrefill?: boolean;
}
